<div
  class="container sm:w-full md:w-[45rem] p-[2rem] h-full flex flex-col justify-center"
>
  <div class="header"> Download Attendance Report </div>
  <div class="content mt-[2rem]">
    <app-search-on-select
      (onNextPage)="groupsOnNextPage()"
      [enableClearSelection]="true"
      [enableMultiple]="true"
      [error]="errorMessages['groupId']"
      [hasNext]="groupFilterList.hasNext"
      [loading]="groupFilterList.loading"
      [options]="groupFilterList.list"
      [parentFormGroup]="form"
      controlName="groupId"
      filterControlName="searchGroup"
      label="Groups"
      optionsPanelClassName="groups-dropdown"
      placeholder="Select all that apply"
      type="small"
    />

    <app-search-on-select
      (onNextPage)="participantsOnNextPage()"
      [enableClearSelection]="true"
      [enableMultiple]="true"
      [error]="errorMessages['groupId']"
      [hasNext]="participantFilterList.hasNext"
      [loading]="participantFilterList.loading"
      [options]="participantFilterList.list"
      [parentFormGroup]="form"
      controlName="participantId"
      filterControlName="searchParticipant"
      label="Participants"
      optionsPanelClassName="participants-dropdown"
      placeholder="Select all that apply"
      type="small"
    />

    <div
      class="date-filter-section flex flex-col md:flex-row md:justify-between mt-[1rem]"
    >
      <app-date-picker
        (checkForErrors)="onDateChange('fromDate')"
        [error]="errorMessages['fromDate']"
        [parentFormGroup]="form"
        class="w-full md:w-[48%]"
        controlName="fromDate"
        label="From"
        placeholder="From"
        type="small"
      ></app-date-picker>
      <app-date-picker
        (checkForErrors)="onDateChange('toDate')"
        [error]="errorMessages['toDate']"
        [min]="form.get('fromDate').value"
        [parentFormGroup]="form"
        class="w-full md:w-[48%]"
        controlName="toDate"
        label="To"
        placeholder="To"
        type="small"
      ></app-date-picker>
    </div>
  </div>
  <div class="actions flex justify-end mt-[2rem]">
    <app-primary-button
      (handleClick)="handleSubmit()"
      class="xs:w-full w-[13rem]"
      type="small"
    >
      Download
    </app-primary-button>
  </div>
</div>
